import React, { lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import Layout from '../components/@common/Layout';
import Login from '../pages/Login';
import ProtectedRoute from './ProtectedRoute';
import LoginRedirect from '@/routes/LoginRedirect';
import Inquiry from '@/components/pages/management/Campaign/Inquiry';
import CampaignAdd from '@/components/pages/management/Campaign/CampaignAdd';
import MobileView from '@/components/@common/MobileCampaign';
import AdvertiserDetail from '@/components/pages/management/Advertiser/AdvertiserDetail';
import CreateAccount from '@/pages/CreateAccount';
import CampaignProductDetail from '@/components/pages/management/CampaignProduct/CampaignProductDetail';
import MobileCampaignList from '@/components/@common/MobileListCampaign';
import Offerwall from '@/components/pages/management//Offerwall';

const CoupangProductMgmt = lazy(() => import('../components/pages/management/CoupangProduct'));


const DashBoard = lazy(() => import('../components/pages/management/DashBoard'));
const User = lazy(() => import('../components/pages/management/User'));
const Advertiser = lazy(() => import('../components/pages/management/Advertiser'));
const Campaign = lazy(() => import('../components/pages/management/Campaign'));
const Log = lazy(() => import('../components/pages/management/Log'));
const Report = lazy(() => import('../components/pages/management/Report'));
const Mypage = lazy(() => import('../components/pages/mypage'));
const RewardReport = lazy(() => import('../components/pages/management/RewardReport'))
const CampaignProduct = lazy(() => import('../components/pages/management/CampaignProduct'))

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <LoginRedirect>
        <Login />
      </LoginRedirect>
    ),
  },
  {
    path: '/createaccount',
    element: <CreateAccount />,
  },
  {
    path: '/admin',
    element: <Layout />,
    children: [
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute allowedRoles={['admin']} allowedCategories={['u']}>
            <DashBoard />
          </ProtectedRoute>
        ),
      },
      {
        path: 'user',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u']}>
            <User />
          </ProtectedRoute>
        ),
      },
      {
        path: 'campaign_product',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u']}>
            <CampaignProduct />
          </ProtectedRoute>
        ),
      },
      {
        path: 'advertiser',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u']}>
            <Advertiser />
          </ProtectedRoute>
        ),
      },
      {
        path: 'rewardreport',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <RewardReport />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mypage',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u']}>
            <Mypage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'log',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <Log />
          </ProtectedRoute>
        ),
      },
      {
        path: 'log/:id',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <Log />
          </ProtectedRoute>
        ),
      },
      {
        path: 'campaign',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <Campaign />
          </ProtectedRoute>
        ),
      },
      {
        path: 'offerwall',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u', 'a', 'c']}>
            <Offerwall />
          </ProtectedRoute>
        ),
      },
      {
        path: 'report',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u', 'a', 'c']}>
            <Report />
          </ProtectedRoute>
        ),
      },
      {
        path: 'coupang_product',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u']}>
            <CoupangProductMgmt />
          </ProtectedRoute>
        ),
      },
      {
        path: 'campaign/inquiry/:id',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <Inquiry />
          </ProtectedRoute>
        ),
      },
      {
        path: 'campaign/add/:id',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <CampaignAdd />
          </ProtectedRoute>
        ),
      },
      {
        path: 'campaign/add',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <CampaignAdd />
          </ProtectedRoute>
        ),
      },
      {
        path: 'advertiser/:id',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super',]} allowedCategories={['u']}>
            <AdvertiserDetail />
          </ProtectedRoute>
        ),
      },
      {
        path: 'campaign_product/:id',
        element: (
          <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
            <CampaignProductDetail />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/admin/campaign/mobileview/:id',
    element: (
      <ProtectedRoute allowedRoles={['admin', 'super', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
        <MobileView />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/mobilelistview',
    element: (
      // <ProtectedRoute allowedRoles={['admin', 'advertiser']} allowedCategories={['u', 'a', 'c']}>
      <MobileCampaignList />
      // </ProtectedRoute>
    ),
  },

  // 모든 알 수 없는 경로들은 홈으로 리다이렉트
  { path: '*', element: <Navigate to="/" replace /> },
]);

export default router;
